// extracted by mini-css-extract-plugin
export default {"closeIcon":"CloseButton_closeIcon__bMqyv"};